import { getToken } from "firebase/messaging";
import { messaging } from "./firebase";
import { saveFcmToken } from "../apis";

export const requestPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey: "BF4P2tMIfZRoa6hYrEr-c00_4DeOfFEDTPzjkCIhNKB-SRo7OjkcB5mle2KeuD0Jb0ImS0kAY2UCkbZDuDJ1xD8",
      });
      
      const user = JSON.parse(localStorage.getItem("userDetails"));
      if (token && user) {
        
        const res = await saveFcmToken({
          fcmToken: token,
          userId: user._id,
        });
        if (res?.status === 200) {
          const updatedUser = { ...user, fcmTokens: token };
          localStorage.setItem("user:detail", JSON.stringify(updatedUser));
        }
      }
    }
  } catch (error) {
    console.log("error in notification", error);
  }
};